export default __webpack_public_path__ + "static/Leaf1-9516483372d43fc9eeab149e3671b836.png";